import { LEAD_NAME_MAX_LENGTH } from './schema'

type LeadNameFields = { first_name: string; last_name: string }

const NAME_FIELD_LIMITS = [
  { field: 'first_name' as const, maxLength: LEAD_NAME_MAX_LENGTH.firstName },
  { field: 'last_name' as const, maxLength: LEAD_NAME_MAX_LENGTH.lastName },
]

/** Truncates first_name/last_name to Salesforce Lead field limits before persistence. */
export function truncateOverLengthLeadNames<T extends LeadNameFields>(body: T): T {
  return NAME_FIELD_LIMITS.reduce((current, { field, maxLength }) => {
    const value = current[field]
    if (value.length <= maxLength) {
      return current
    }

    return { ...current, [field]: value.slice(0, maxLength) }
  }, body)
}
